export const strategyToOptions = (strategy: { [key: string]: string; }) => {
  return Object.entries(strategy).map(([value, label]) => ({ value, label }));
};
